export default function CMultidimensionalArrays() {
  return <h2>C Multidimensional Arrays</h2>;
}
